"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RUNDIFFUSION_SITE_VERIFICATION_TXT_KEY = void 0;
exports.formatDomainClaimDnsTxtRecord = formatDomainClaimDnsTxtRecord;
exports.normalizeDnsTxtRdata = normalizeDnsTxtRdata;
exports.dnsTxtRdataMatchesDomainClaimSecret = dnsTxtRdataMatchesDomainClaimSecret;
/**
 * DNS TXT value for domain claim verification uses `KEY=<secret>` so customers can keep other TXT
 * records (SPF, etc.) and recognize ours by name. The secret alone is still what we store in
 * companySecrets; publish the full formatted string in DNS.
 */
exports.RUNDIFFUSION_SITE_VERIFICATION_TXT_KEY = 'rundiffusion-site-verification';
/** Full TXT RDATA to publish: `rundiffusion-site-verification=<secret>`. */
function formatDomainClaimDnsTxtRecord(secretToken) {
    return `${exports.RUNDIFFUSION_SITE_VERIFICATION_TXT_KEY}=${secretToken}`;
}
/** Strip common DNS UI wrapping of TXT values in double quotes. */
function normalizeDnsTxtRdata(value) {
    return String(value || '').replace(/^"+|"+$/g, '').trim();
}
/**
 * True if a TXT RDATA string proves ownership for the stored secret: current `key=<secret>` form,
 * or legacy bare `secret` (tokens issued before namespacing).
 */
function dnsTxtRdataMatchesDomainClaimSecret(secretToken, txtRdata) {
    const normalized = normalizeDnsTxtRdata(txtRdata);
    if (!secretToken || !normalized) {
        return false;
    }
    if (normalized === secretToken) {
        return true;
    }
    const prefix = `${exports.RUNDIFFUSION_SITE_VERIFICATION_TXT_KEY}=`;
    if (!normalized.startsWith(prefix)) {
        return false;
    }
    return normalized.slice(prefix.length) === secretToken;
}
